var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize",attrs:{"loading":_vm.loading,"outlined":"","small":"","color":"secondary"},on:{"click":_vm.announce}},[_vm._v("Announce Invoices")])
}
var staticRenderFns = []

export { render, staticRenderFns }